$shm_dashboard_admin_user_add $mol_page
	title \Добавить пользователя
	email? \
	password? \
	name? \
	message? \
	created? \
	body /
		<= Email_label $mol_labeler
			title \Email
			content /
				<= Email $mol_string
					hint \user@example.com
					value? <=> email? \
		<= Name_label $mol_labeler
			title \Имя
			content /
				<= Name $mol_string
					hint \Имя
					value? <=> name? \
		<= Password_label $mol_labeler
			title \Пароль
			content /
				<= Password $mol_password
					value? <=> password? \
					submit? <=> submit? null
		<= Submit $mol_button_major
			title \Добавить
			- enabled <= submit_enabled true
			click? <=> submit? null
		<= Message $mol_text
			text <= message? \
